import { render, staticRenderFns } from "./SideNavLayout.vue?vue&type=template&id=28dbdcf6&scoped=true&"
import script from "./SideNavLayout.vue?vue&type=script&lang=js&"
export * from "./SideNavLayout.vue?vue&type=script&lang=js&"
import style0 from "./SideNavLayout.vue?vue&type=style&index=0&id=28dbdcf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dbdcf6",
  null
  
)

export default component.exports